export const convertDateToLocalDate = (date, formatter) => {
    if (!date)
        return undefined;
    const formattedDate = formatter(date.toISOString());
    return new Date(formattedDate);
};
